// The Network carousel doesn't have real participating-business data wired
// up yet, so rather than inventing fake business names, these are honest
// "coming soon" placeholders grouped by category. Replace with real
// businesses (name, neighborhood, photo, points-per-visit) as they join.
const VENUES = [
  { id: 'v1', category: 'Restaurants' },
  { id: 'v2', category: 'Cafés' },
  { id: 'v3', category: 'Retail & Shops' },
  { id: 'v4', category: 'Salons & Services' },
  { id: 'v5', category: 'Bookstores' },
  { id: 'v6', category: 'Fitness & Wellness' },
];

export default VENUES;
